import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTemplateCarouselStyles = makeStyles({
  carousel: {
    display: 'flex',
    width: '600px',
    height: '380px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  carouselItemContainer: {
    backgroundColor: tokens.colorNeutralBackground6,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.padding(tokens.spacingVerticalNone, '64px'),
  },
  carouselItem: {
    maxHeight: '100%',
    maxWidth: '100%',
    boxShadow: tokens.shadow2,
  },
});
